// @flow
import { type State } from 'app/common/ui-components/filter';

import { flags as org } from '../org';


const yearActivity = (state: State) => {
  return (
    org.filterActive(state)
    && org.singleOrgSelected(state)
  );
};

export default yearActivity;
